<script>
import draggable from 'vuedraggable'
import { cloneDeep } from 'lodash'
const argsList = [
  [
    { id: '1', name: '11', show: true },
    { id: '22', title: 'title', group: [{ id: '2', name: '22', show: true }] },
  ],
  [{ id: '3', name: '33', show: true }],
  [{ id: '4', name: '44', show: false }],
]
import ArgTag from './ArgTag'
import ArgTagGroup from './ArgTagGroup'

export default {
  name: 'ArgTabPane',
  components: {
    draggable,
    ArgTag,
    ArgTagGroup,
  },
  props: {
    localArgsList: {
      type: Array,
      default: () => [[], [], []],
    },
  },
  data() {
    return {
      dragOptions: {
        animation: 0,
        group: 'args',
        ghostClass: 'ghost',
      },
      argsList,
    }
  },
  watch: {
    localArgsList: {
      handler(val) {
        this.argsList = cloneDeep(val)
      },
      immediate: true,
    },
  },
  methods: {
    createGroup() {
      this.argsList[0].push({ id: String(Date.now()), title: this.$t('page_mdc_realtime_create_group'), group: [] })
    },
    deleteGroup(array, i) {
      array[i].group.forEach(item => {
        array.push(item)
      })
      this.$delete(array, i)
    },
  },
  render() {
    return (
      <div class="pt-4">
        <a-row type="flex">
          {this.argsList.map((args, index) => (
            <a-col span={8} class="bd-1-solid-grey">
              <draggable class="pa-2 min-h-8" v-model={this.argsList[index]} attrs={this.dragOptions}>
                {this.argsList[index].map((arg, i) =>
                  !arg.group ? (
                    <ArgTag key={arg.id} arg={arg} onChange={show => (arg.show = show)} />
                  ) : (
                    <ArgTagGroup
                      argGroup={arg}
                      key={arg.id}
                      onChange={title => (arg.title = title)}
                      onDel={() => this.deleteGroup(this.argsList[index], i)}
                    />
                  )
                )}
              </draggable>
            </a-col>
          ))}
        </a-row>
        <add-button onClick={this.createGroup}>{this.$t('page_mdc_realtime_create_group')}</add-button>
      </div>
    )
  },
}
</script>